<div (click)="goToProfile(ambassador.user)" class="tooltip">
  <div class="ambassador">
    <div class="ambassador__image">
      <div
        [ngStyle]="{
          background: 'url(' + ambassador.avatar + ')',
          height: '80px',
          backgroundSize: 'cover',
          borderRadius: '50px'
        }"
      ></div>
    </div>

    <div class="ambassador__info">
      <div class="ambassador__name">
        {{ ambassador.name }}
      </div>

      <div class="ambassador__country">
        {{ ambassador.country }}
      </div>

      <button class="btn btn--outline btn--xs btn--primary" style="margin-top: 8px">
        <span>{{ 'ACCOUNT.see_profile' | translate }}</span>
      </button>
    </div>
  </div>
</div>
